module.exports = __webpack_public_path__ + "img/393.c57da618.jpg";